import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { CustomTablePropsTypes } from '../types';

/**
 * Generic component of table for coupon management 
 * @param props 
 * @returns 
 */

function CustomTable(props: CustomTablePropsTypes) {

    const {columns , rows ,tableProps ,tableHeadCellProps,tableRowCellProps,tableHeadProps,tableContainerProps} = props;
    const tableHeadCellStyles:any= tableHeadCellProps?.style ? {...tableHeadCellProps.style} :{}
    
    return (
        <TableContainer component={Paper}  {...tableContainerProps}>
            <Table {...tableProps}>
                <TableHead {...tableHeadProps}>
                    <TableRow>
                        {
                            columns.map((col:{label:string|React.ReactNode , dataIndex?:string | number,style?:object},idx:number) => <TableCell key={col?.dataIndex ?? idx} {...tableHeadCellProps} style={{...tableHeadCellStyles , ...col.style}} >{col.label}</TableCell>)
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows && rows?.map((row: any,idx:number) => (
                        <TableRow key={`row:`+idx}>
                            {
                                row.map((item: any , index:number) => <TableCell key={`rowcell_`+index} {...tableRowCellProps}>
                                    {item}
                                </TableCell>)
                            }
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default React.memo(CustomTable)